<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold pt-2" v-html="title" />
    <div class="col-12 col-md-8 col-xl-9">
      <div class="row pt-2">
        <div class="col-12 col-lg-4">
          <span class="d-block pb-2">OSB-Platte</span>
          <button type="button"
            v-for="(item, index) in items.osb"
            :key="'osb-' + index"
            :class="['btn btn-sm btn-outline-filter btn-inner-planking', filterUiState('innerPlanking1', item.value)]"
            v-on:click="selectValue(item.value)">{{ item.title }}</button>
        </div>
        <div class="col-12 col-lg-4">
          <span class="d-block pb-2">Gipsfaserplatte</span>
            <button type="button"
              v-for="(item, index) in items.gypsumplate"
              :key="'gypsumplate-' + index"
              :class="['btn btn-sm btn-outline-filter btn-inner-planking', filterUiState('innerPlanking1', item.value)]"
              v-on:click="selectValue(item.value)">{{ item.title }}</button>
        </div>
        <div class="col-12 col-lg-4">
          <span class="d-block pb-2">Spanplatte</span>
          <button type="button"
            v-for="(item, index) in items.chipboard"
            :key="'chipboard-' + index"
            :class="['btn btn-sm btn-outline-filter btn-inner-planking', filterUiState('innerPlanking1', item.value)]"
            v-on:click="selectValue(item.value)">{{ item.title }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionInnerPlanking1',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'Beplankung Innen 1. Lage',
      items: {
        osb: [
          { title: '12 mm', value: 'ia-12' },
          { title: '15 mm', value: 'ib-15' }
        ],
        // plasterboard: [
        //  { title: '9,5 mm', value: 'ic-9' },
        //  { title: '12,5 mm', value: 'id-12' }
        // ],
        gypsumplate: [
          { title: '12,5 mm', value: 'if-12' },
          { title: '15 mm', value: 'ig-15' },
          //{ title: '18 mm', value: 'ih-18' }
        ],
        chipboard: [
          { title: '16 mm', value: 'ii-16' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      let result = this.items.osb.filter(item => item.value === value)
      // if (result.length <= 0) result = this.items.plasterboard.filter(item => item.value === value)
      if (result.length <= 0) result = this.items.gypsumplate.filter(item => item.value === value)
      if (result.length <= 0) result = this.items.chipboard.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('innerPlanking1', value)


      let category = this.title
      if (this.items.osb.some(el => el.value === value)) {
          category += '-OSB-Platte'
      }
      // else if ( this.items.plasterboard.some(el => el.value === value)) {
      //     category += '-Gipskartonplatte'
      // }
      else if ( this.items.gypsumplate.some(el => el.value === value)) {
          category += '-Gipsfaserplatte'
      }
      else if ( this.items.chipboard.some(el => el.value === value)) {
          category += '-Spanplatte'
      }


      this.$gtm.trackEvent({
        event: 'filter',
        category: category,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: value
      })

      this.$store.dispatch('filter/setValue', {
        name: 'innerPlanking1',
        title: category + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
